var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C30929",
    d: "M14.531 2.49a8.503 8.503 0 0 0-12.02 0 8.503 8.503 0 0 0 0 12.02 8.503 8.503 0 0 0 12.02 0 8.503 8.503 0 0 0 0-12.02Zm-4.207 9.015L8.52 9.702l-1.803 1.803a.852.852 0 0 1-1.202 0 .852.852 0 0 1 0-1.202L7.319 8.5 5.516 6.697a.852.852 0 0 1 0-1.202.852.852 0 0 1 1.202 0L8.52 7.298l1.803-1.803a.852.852 0 0 1 1.202 0c.33.33.33.871 0 1.202L9.723 8.5l1.803 1.803c.33.33.33.872 0 1.202a.852.852 0 0 1-1.202 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimDeactivated);
export default __webpack_public_path__ + "static/media/SimDeactivated.1e1f128d1623cd596fcc084ede74eb1a.svg";
export { ForwardRef as ReactComponent };